import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 .5c1.113 0 2.191.133 3.214.38a5.98 5.98 0 0 0-.944 1.836A11.844 11.844 0 0 0 12 2.5C6.218 2.5 2 6.548 2 11c0 1.602.522 3.112 1.458 4.415l.523.726-1.027 4.628 6.3-1.585.443.089c.737.148 1.508.227 2.303.227 5.782 0 10-4.048 10-8.5a7.08 7.08 0 0 0-.048-.825 5.988 5.988 0 0 0 1.86-1.04A9.28 9.28 0 0 1 24 11c0 5.799-5.373 10.5-12 10.5-.928 0-1.83-.092-2.697-.266L.3 23.5l1.533-6.918C.672 14.965 0 13.052 0 11 0 5.201 5.373.5 12 .5ZM5.44 12.06a1.5 1.5 0 1 0 2.12-2.12 1.5 1.5 0 0 0-2.12 2.122Zm13.12 0a1.5 1.5 0 1 1-2.12-2.121 1.5 1.5 0 0 1 2.12 2.122ZM20 8.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-6.94 1.44a1.5 1.5 0 1 1-2.121 2.12 1.5 1.5 0 0 1 2.122-2.12Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionMessageUnread24 = createIcon(IconComponent);